import { DEDUCTIONS } from "..";
import { apiInstance } from "../config/apiInstance";

export const deleteDeduction = async (id: number): Promise<void> => {
  await apiInstance.delete(`${DEDUCTIONS}/${id}`);
};
